"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var HabitatFit_exports = {};
__export(HabitatFit_exports, {
  default: () => HabitatFit_default
});
module.exports = __toCommonJS(HabitatFit_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.418 3.66797C16.6003 3.66797 16.7565 3.73307 16.8867 3.86328C17.0169 3.99349 17.082 4.14974 17.082 4.33203V16.168C17.082 16.3503 17.0169 16.5065 16.8867 16.6367C16.7565 16.7669 16.6003 16.832 16.418 16.832H4.58203C4.39974 16.832 4.24349 16.7669 4.11328 16.6367C3.98307 16.5065 3.91797 16.3503 3.91797 16.168V4.33203C3.91797 4.14974 3.98307 3.99349 4.11328 3.86328C4.24349 3.73307 4.39974 3.66797 4.58203 3.66797H16.418ZM4.58203 2.67188C4.1263 2.67188 3.73568 2.83464 3.41016 3.16016C3.08464 3.48568 2.92188 3.8763 2.92188 4.33203V16.168C2.92188 16.6237 3.08464 17.0143 3.41016 17.3398C3.73568 17.6654 4.1263 17.8281 4.58203 17.8281H16.418C16.8737 17.8281 17.2643 17.6654 17.5898 17.3398C17.9154 17.0143 18.0781 16.6237 18.0781 16.168V4.33203C18.0781 3.8763 17.9154 3.48568 17.5898 3.16016C17.2643 2.83464 16.8737 2.67188 16.418 2.67188H4.58203ZM14.1328 6.61719C14.2109 6.69531 14.25 6.79297 14.25 6.91016C14.25 7.02734 14.2109 7.125 14.1328 7.20312L7.45312 13.8828C7.375 13.9609 7.27734 14 7.16016 14C7.04297 14 6.94531 13.9609 6.86719 13.8828C6.78906 13.8047 6.75 13.707 6.75 13.5898C6.75 13.4727 6.78906 13.375 6.86719 13.2969L13.5469 6.61719C13.625 6.53906 13.7227 6.5 13.8398 6.5C13.957 6.5 14.0547 6.53906 14.1328 6.61719ZM10.5 14C10.5 14.1172 10.4609 14.2148 10.3828 14.293C10.3047 14.3711 10.207 14.4102 10.0898 14.4102H6.33984V10.6602C6.33984 10.543 6.37891 10.4453 6.45703 10.3672C6.53516 10.2891 6.63281 10.25 6.75 10.25C6.86719 10.25 6.96484 10.2891 7.04297 10.3672C7.12109 10.4453 7.16016 10.543 7.16016 10.6602V13.5898H10.0898C10.207 13.5898 10.3047 13.6289 10.3828 13.707C10.4609 13.7852 10.5 13.8828 10.5 14ZM10.5 6.5C10.5 6.38281 10.5391 6.28516 10.6172 6.20703C10.6953 6.12891 10.793 6.08984 10.9102 6.08984H14.6602V9.83984C14.6602 9.95703 14.6211 10.0547 14.543 10.1328C14.4648 10.2109 14.3672 10.25 14.25 10.25C14.1328 10.25 14.0352 10.2109 13.957 10.1328C13.8789 10.0547 13.8398 9.95703 13.8398 9.83984V6.91016H10.9102C10.793 6.91016 10.6953 6.87109 10.6172 6.79297C10.5391 6.71484 10.5 6.61719 10.5 6.5Z",
      fill: "currentColor"
    }
  )
);
const SvgHabitatFit = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var HabitatFit_default = SvgHabitatFit;
